import React, { useState, useEffect } from 'react'
import { useTranslations } from '@shared/context/useTranslations';
import ModelImg from "../../../assets/login/model_png.png";
import { HMF_Image } from "@shared/components/Atoms/Image/image.component";
import { useCrane } from '@shared/context/CraneContext';
import { IconNames } from '@shared/enums/icons.enums';
import { Icon } from '@shared/components/Molecules/Icon/Icon.component';
import useCurrentCulture from '@shared/hooks/useCurrentCulture';
import S from './CraneSearchBlock.module.scss'

export const CraneSearchBlock: React.FC = () => {
    const { getTranslation } = useTranslations();
    const { currentCulture } = useCurrentCulture();
    const { craneInfo  } = useCrane();
    const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined);

    useEffect(() => {
        setDownloadUrl(craneInfo?.sparePartCatalogueUri?.[currentCulture] || undefined);
    }, [craneInfo, currentCulture]);

    return (
        <div className={S.craneSearchBlock}>
            <div className={S.searchContent}>
                <h2 className={S.searchTitle}>{getTranslation("craneSearch.title", { name: craneInfo?.craneName || ""})}</h2>
                <p className={S.searchDescription}>{getTranslation("craneSearch.description")}</p>
            </div>

            {downloadUrl ? (
                <a href={downloadUrl} target='_blank' rel='noreferrer' download className={S.downloadLink}>
                    <Icon className={S.downloadIcon} iconName={IconNames.Pdf} />
                    <span>{getTranslation("craneSearch.download")}</span>
                </a>
            ) : null}

            <div className={S.modelImg}>
                <HMF_Image className={S.imageLeft} src={ModelImg} alt="model" />
                <HMF_Image className={S.imageRight} src={ModelImg} alt="model" />
            </div>
        </div>
    )

}